module.exports = __webpack_public_path__ + "static/media/finideas-logo-white-small.b396d40e.png";